/* Diamond Domain - shape switcher placement (Sep 2026).

   The switcher is rendered at the end of the page by layout/theme.liquid and moved into the
   form here. dd-optionstack.js later moves it again, into the option list proper. That avoids
   editing templates/product.json - 15KB of escaped JSON where one bad escape takes down every
   product page.

   IMPORTANT: choosing a metal makes the theme re-render <variant-selects>, which by then
   CONTAINS the switcher - so the switcher is destroyed outright, not merely detached. A
   pristine copy is kept from the first sighting and re-cloned whenever it goes missing.
   dd-pdp.js drives the re-run.

   Delete this file and its line in layout/theme.liquid to revert. */
(function () {
  var ID = 'dd-shape-siblings';
  var pristine = null;

  /* Each ring in a sibling family carries Shape as a variant option with exactly one value,
     so the form renders a "Shape" group containing a single dead button. With the switcher
     above it, the page would show Shape twice - once useful, once inert. Hide the inert one,
     and hide its wrapper too, or it leaves an empty gap where the margin used to be. */
  function hideRedundantShapeOption() {
    document.querySelectorAll('.product__form__wrapper fieldset.radio__fieldset').forEach(function (fs) {
      var legend = fs.querySelector('legend, .radio__legend__label');
      if (!legend) return;
      if (legend.textContent.replace(/\s+/g, ' ').trim().toLowerCase() !== 'shape') return;

      var choices = fs.querySelectorAll('input[type=radio]').length;
      if (choices > 1) return;

      var target = fs.closest('.selector-wrapper') || fs;
      target.style.display = 'none';
      target.setAttribute('data-dd-hidden-single-option', 'true');
    });
  }

  function place() {
    var block = document.getElementById(ID);

    if (!block) {
      if (!pristine) return true;   /* not a family product - nothing to do */
      block = pristine.cloneNode(true);
      document.body.appendChild(block);
    } else if (!pristine) {
      /* captured before any placement, so the copy is hidden and unplaced */
      pristine = block.cloneNode(true);
    }

    if (block.dataset.ddPlaced === '1') {
      hideRedundantShapeOption();
      return true;
    }

    var anchor =
      document.querySelector('.product__block.product__form__wrapper') ||
      document.querySelector('.product__block.product__price-and-badge');

    if (!anchor) return false;

    anchor.parentNode.insertBefore(block, anchor);
    block.dataset.ddPlaced = '1';
    block.hidden = false;

    var current = block.querySelector('.dd-shape-swatch.is-current');
    var label = block.querySelector('[data-dd-current-shape]');
    if (current && label) label.textContent = current.getAttribute('data-dd-shape') || '';

    hideRedundantShapeOption();
    return true;
  }

  (window.__ddInit = window.__ddInit || []).push(place);

  function start() {
    if (place()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (place() || ++tries > 20) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();